export default __webpack_public_path__ + "static/media/promo-top-bg.56573e9d.svg";